export default __webpack_public_path__ + "static/media/bloodmana.004ad821.png";